import { Pipe, PipeTransform } from '@angular/core';
import { filter } from 'lodash';

@Pipe({
  name: 'filterBy',
  standalone: true,
})
export class FilterByPipe<T> implements PipeTransform {
  transform(array: T[], predicate: any): T[] {
    return filter(array, predicate);
  }
}
